<template>
  <div>
    <!-- Agency Logo and Sign in-->
    <v-row>
      <v-col>
        <v-img src='agency.svg' alt="" />
      </v-col>
      <v-col class="hidden-sm-and-down">
        <v-form>
          <v-container>
            <v-card elevation="0">
              <v-card-title>
                Sign in
              </v-card-title>
              <v-card-text class="mt-n4">
                <v-row>
                  <v-col>
                    <v-text-field label="Username" placeholder="Email or mobile number" v-model="username" outlined
                      dense></v-text-field>
                  </v-col>
                  <v-col>
                    <v-text-field label="Password" v-model="password" placeholder="Password" type="password"
                      v-on:keydown.enter="login" outlined dense></v-text-field>
                  </v-col>
                  <v-col>
                    <v-btn @click="login" tile color="success">
                      <v-icon left>
                        mdi-login
                      </v-icon>
                      LOGIN
                    </v-btn>
                  </v-col>
                </v-row>
                <p v-if="errorMsg" class="subtitle error-msg mt-n8">{{ errorMsg }}</p>
              </v-card-text>
              <v-card-actions>
                <v-btn to="/forgot_password" class="mt-n16" text color="primary">
                  Forgot Password?
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-container>
        </v-form>
      </v-col>

    </v-row>
    <!-- Toolbar-->
    <v-row>
      <v-toolbar color="teal darken-2" dark>
        <v-toolbar-items class="hidden-sm-and-down">
          <v-btn text>
            Home
          </v-btn>

          <v-divider class="mx-4" vertical></v-divider>

          <v-btn text>
            About
          </v-btn>

          <v-divider class="mx-4" vertical></v-divider>

          <v-btn text>
            Resources
          </v-btn>

          <v-divider vertical></v-divider>

          <v-btn text>
            Statistics
          </v-btn>

          <v-divider class="mx-4" vertical></v-divider>

          <v-btn text>
            Employment
          </v-btn>


          <v-divider class="mx-4" vertical></v-divider>

          <v-btn text>
            Services
          </v-btn>

          <v-divider class="mx-4" vertical></v-divider>

          <v-btn text>
            Beat COVID-19
          </v-btn>
          <v-divider vertical></v-divider>
        </v-toolbar-items>
        <v-spacer></v-spacer>

        <v-btn text>
          {{ get_current_local_time() }}
        </v-btn>

      </v-toolbar>
    </v-row>
    <!-- Image carousel and Signup or login-->
    <v-row>
      <v-col md="7" sm=12>
        <v-carousel cycle hide-delimiter-background show-arrows-on-hover height="100%">
          <v-carousel-item v-for="(image, i) in carousel_images" :key="i">
            <v-sheet height="100%">
              <v-row class="fill-height" align="center" justify="center">
                <v-img :src="image" />
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-col>
      <v-col md="5" sm=12>
        <v-card class="pa-2" color="grey lighten-3">
          <!-- Create Account Card-->
          <v-card color="cyan lighten-5" class="mx-auto px-8" elevation="2">
            <v-card-title class="justify-center">
              Create Account
            </v-card-title>
            <v-card-text>
              <v-btn color="error" to="/signup_client" x-large block>
                <v-icon>mdi-account</v-icon>
                For Service-Users
              </v-btn>
              <v-btn class="mt-8" color="cyan darken-1" to="/signup_health_care" x-large dark block>
                <v-icon>mdi-asterisk</v-icon>
                For Providers
              </v-btn>
            </v-card-text>
            <v-card-actions>
              <p>By clicking for Service-Users or For Providers, you agree to our
                <a :href="about">Terms of Services</a> and
                <router-link to="/privacy">Privacy Policy</router-link>
              </p>
            </v-card-actions>

          </v-card>
          <!--Already have an account-->
          <v-card color="cyan lighten-5" class="mx-auto mt-2 px-8" elevation="2">
            <v-card-subtitle class="text-center body-1">
              Already have an account?
            </v-card-subtitle>
            <v-card-text>
              <v-btn color="success" to="/login" x-large block>
                <v-icon>mdi-account</v-icon>
                Log in
              </v-btn>
            </v-card-text>
          </v-card>

        </v-card>
      </v-col>
    </v-row>
    <!-- Guide -->
    <v-row>
      <v-col cols="9"></v-col>
      <v-img src="guide.svg"></v-img>
      <v-col cols="3" class="hidden-sm-and-down" align="center">
        <v-img src="misc.svg"></v-img>
        <v-img src="pap_logo.png" max-width="280px"></v-img>
      </v-col>
    </v-row>

    <!-- Agency Footer -->
    <v-row height="10" color="grey">
      <v-card color="grey"></v-card>
    </v-row>

    <!-- Main Footer -->
    <v-footer color="grey lighten-3" class="pa-10">
      <v-card color="grey lighten-3" elevation="0">

        <v-row>
          <v-col>
            <v-card>
              <v-img src="govph.png"></v-img>
            </v-card>
          </v-col>
          <v-col>
            <v-card color="grey lighten-3" elevation="0">
              <v-card-text>
                <strong>REPUBLIC OF THE PHILIPPINES</strong><br />
                All content is in the public domain otherwise stated.
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card color="grey lighten-3" elevation="0">
              <v-card-text>
                <div><strong>ABOUT GOVPH</strong></div>
                <div>Learn more about the Philippine government, its structure, how government works and the people
                  behind it.</div>
                <div class="mt-5">
                  <a href="">GOV.PH</a><br />
                  <a href="">Open Data Portal</a><br />
                  <a href="">Official Gazette</a>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card color="grey lighten-3" elevation="0">
              <v-card-text>
                <div><strong>GOVERNMENT LINKS</strong></div>
                <div class="mt-5">
                  <a href="">Office of the President</a><br />
                  <a href="">Office of the Vice President</a><br />
                  <a href="">Senate of the Philippines</a><br />
                  <a href="">House of Representatives</a><br />
                  <a href="">Supreme Court</a><br />
                  <a href="">Court of Appeals</a><br />
                  <a href="">Sandiganbayan</a><br />

                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-divider class="my-8"></v-divider>
        <v-card-title class="justify-center">
          {{ new Date().getFullYear() }} — <strong>MentalHealthPH</strong>
        </v-card-title>

      </v-card>


    </v-footer>
    <!-- <v-card-text class="py-2 teal darken-4 white--text text-center">
          {{ new Date().getFullYear() }} — <strong>MentalHealthPH</strong>
        </v-card-text> -->
  </div>
</template>

<script>
import moment from 'moment'
import { EventBus } from '../utils'

export default {
  name: "landing",
  data: () => ({
    absolute: true,
    overlay: false,
    carousel_images: [
      'banner_1.svg'
    ],
    username: "",
    password: "",
    errorMsg: ""

  }),
  mounted() {
    EventBus.$on('failedAuthentication', (msg) => {
      this.errorMsg = msg
    })
  },
  beforeDestroy() {
    EventBus.$off('failedAuthentication')
  },
  methods: {
    get_current_local_time: function () {
      return moment().format('LLLL');
    },
    login: function () {
      this.$store.dispatch('login', { username: this.username, password: this.password })
        .then(() => this.$router.push('/'))
    }

  },

}
</script>

<style scoped>
.error-msg {
  color: red;
  font-weight: bold;
}
</style>>